/**
 * © [2025] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import { setErrorMessages, setGridData } from '../../Store/Actions';
import { CPT_CODE_REQUIRED } from '../../../../../SharedModules/Errors/constantMessageData';

// custom function import
export default (props) => {
  const dispatch = useDispatch();
  const gridData = useSelector((state) => {
    return state.sharedState.IneligibleCPTReducer?.gridData;
  });
  const { colId } = props.column;
  const { data, fieldsDisabled } = props;
  const errorMessagesFromRedux = useSelector((state) => {
    return state.sharedState.IneligibleCPTReducer?.errorMessagesInRedux;
  });
  let rowIndexId = 0;
  if (gridData && gridData.length > 0) {
    rowIndexId = gridData?.findIndex((x) => {
      return x.tempId === data.tempId;
    });
  }
  // call onBlur event and check validation
  const handleChange = (e) => {
    if (fieldsDisabled) return;
    const newObj = [...gridData];
    let localErr = errorMessagesFromRedux || [];
    newObj[rowIndexId].procedureCd = e.target.value;
    props.node.setDataValue('procedureCd', e.target.value);
    newObj[rowIndexId].addEditRow = true;
    if (e.target.value === '' || e.target.value === null) {
      newObj[rowIndexId].procedureCdErr = true;
      localErr.push({
        fieldName: `${colId}${rowIndexId}`,
        errorType: 'CPTcodeRequired',
        message: `${CPT_CODE_REQUIRED} ${rowIndexId + 1}.`,
      });
    } else {
      newObj[rowIndexId].procedureCdErr = false;
      localErr = localErr?.filter(
        (item) =>
          item.fieldName !== `${colId}${rowIndexId}` &&
          item.errorType !== 'CPTcodeRequired'
      );
    }
    dispatch(setGridData(newObj));
    dispatch(setErrorMessages([...new Set(localErr)]));
  };

  return (
    <div data-testid="maintain-cpt-text-box">
      <TextField
        autoComplete="off"
        id={`${colId}_${rowIndexId}`}
        label={colId}
        className={
          gridData &&
          gridData[rowIndexId] &&
          gridData[rowIndexId].procedureCdErr !== undefined &&
          gridData[rowIndexId].procedureCdErr
            ? 'td-active-cell tBill-validate frr-display-hidden-label'
            : 'frr-display-hidden-label'
        }
        data-testid="procedureCd"
        fullWidth
        disabled={fieldsDisabled}
        placeholder=""
        InputLabelProps={{ shrink: true }}
        inputProps={{
          maxLength: 20,
          id: `${colId}_${rowIndexId}`,
        }}
        value={data?.procedureCd}
        onChange={handleChange}
        onBlur={(e) => {
          handleChange(e);
        }}
      />
    </div>
  );
};
